import dayjs from "dayjs";
import type { RobotTimeline } from "../types/Robot";
export const MIN_MS = 60 * 1000;
export const HOUR_MS = 60 * MIN_MS;
export const DAY_MS = 24 * HOUR_MS;

const NICE_INTERVALS_MS: number[] = [
	MIN_MS,
	5 * MIN_MS,
	15 * MIN_MS,
	30 * MIN_MS,
	HOUR_MS,
	2 * HOUR_MS,
	3 * HOUR_MS,
	6 * HOUR_MS,
	12 * HOUR_MS,
	DAY_MS,
	2 * DAY_MS,
	7 * DAY_MS,
];

export const chooseTickInterval = (durationMs: number, targetMaxTicks = 8): number => {
	for (const interval of NICE_INTERVALS_MS) {
		if (durationMs / interval <= targetMaxTicks) return interval;
	}
	return NICE_INTERVALS_MS[NICE_INTERVALS_MS.length - 1];
};

export const generateTicks = (windowStartMs: number, windowEndMs: number, intervalMs: number): number[] => {
	const aligned = intervalMs >= DAY_MS ? dayjs(windowStartMs).startOf("day") : dayjs(windowStartMs).startOf("hour");
	let firstTick = aligned.valueOf();
	while (firstTick < windowStartMs) firstTick += intervalMs;
	const ticks: number[] = [];
	for (let t = firstTick; t <= windowEndMs; t += intervalMs) ticks.push(t);
	return ticks;
};

export const formatTick = (ms: number, intervalMs: number): string => {
	const d = new Date(ms);
	if (intervalMs < DAY_MS) {
		return d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
	}
	return d.toLocaleDateString([], { month: "short", day: "numeric" });
};

export interface TrimmedSegment {
	segment: RobotTimeline;
	start: number;
	end: number;
}

export const trimToWindow = (timeline: RobotTimeline[], windowStart: number, windowEnd: number): TrimmedSegment[] => {
	return timeline
		.filter((s) => s.start <= windowEnd && s.end >= windowStart)
		.map((segment) => ({
			segment,
			start: Math.max(segment.start, windowStart),
			end: Math.min(segment.end, windowEnd),
		}));
};

export const formatDateTime = (ms: number): string => new Date(ms).toLocaleString();
